import React from 'react';
import { Chip } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import InfoIcon from '@mui/icons-material/Info';
import type { Severity } from '../../types/changeDetection.types';

interface SeverityBadgeProps {
  severity: Severity;
  size?: 'small' | 'medium';
}

const severityConfig: Record<Severity, {
  color: 'error' | 'warning' | 'default';
  icon: React.ElementType;
  label: string;
}> = {
  HIGH: {
    color: 'error',
    icon: WarningIcon,
    label: 'High'
  },
  MEDIUM: {
    color: 'warning',
    icon: InfoIcon,
    label: 'Medium'
  },
  LOW: {
    color: 'default',
    icon: InfoIcon,
    label: 'Low'
  }
};

export const SeverityBadge: React.FC<SeverityBadgeProps> = ({ severity, size = 'medium' }) => {
  const config = severityConfig[severity];
  const Icon = config.icon;

  return (
    <Chip
      label={config.label}
      color={config.color}
      size={size}
      icon={<Icon />}
      sx={{ fontWeight: 500 }}
    />
  );
};
